<template>
    <!-- 听书榜单分类 -->
    <div class="main">
        <div class="margin-box paddingH16">
            <div class="recent-changes">
                <!-- 标题 -->
                <!-- <div class="title">
                    <div class="title-link">
                        <h3>往期榜单</h3>
                    </div>
                </div> -->
                <!-- 榜单内容 -->

                <!-- remove for v7.0 design drawing -->
<!--                <div class="marginT12 paddingV16 white_bg">-->
<!--                    <adModule :type="adTypeEnum.LISTEN_INDEX.code" version="4"/>-->
<!--                </div>-->

                <div class="content">
                    <div class="example-nav">
                        <div class="example-title bold" style="float:left;">
                            听书榜单
                        </div>
                        <ul style="float:right;" class="nav-box">
                            <li :class="[index === currentIndex ? 'active' : '']" @click="currentLink(index)"
                                v-for="(item , index) in exampleNavList" :key="index">
                                <span>
                                    {{item}}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="example-content hiddenScrollbar">
                        <div :style="{'display':currentIndex !== index ? 'none' : ''}" class="example-list"
                             v-for="(item , index) in exampleNavList.length" :key="index">
                            <!-- <div v-if="currentIndex === index"> -->
                            <!-- <div v-for="(sumItem , index) in exampleContentList[currentIndex]" :key="index"> -->
                            <ul class="example-box" v-if="currentIndex === index">
                                <li :class="[(index === 2 || index === 5 || index === 8) ? 'radius-active' : '']"
                                    :style="{'border-radius':(index === 0 || index === 3 || index === 6) ? '4px 4px 0 0' :''}"
                                    class="choiceness-model" v-for="(sumItem , index) in dataList.slice(0,9)"
                                    :key="index" @click="toDetail(sumItem.id)">
                                    <div class="choiceness-item">
                                        <div class="choiceness-sort">
                                            <img :src="startStr+(index+1)+endStr" style="width:38px;height:26px">
                                        </div>
                                        <div class="choiceness-img">
                                            <img :src="sumItem.coverImg" alt="榜单图片">
                                            <div class="img-shade">
                                                <i class="choiceness-play"></i>
                                            </div>
                                        </div>
                                        <div class="choiceness-right">
                                            <div class="choicenss-title">{{sumItem.title}}</div>
                                            <div class="choicenss-param">
                                                <div class="example-listenSum">{{sumItem.playCount || 0}}人收听</div>
                                                <div class="example-sum">
                                                    已更新
                                                    {{sumItem.segCount ? sumItem.segCount : 0}}
                                                    节
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="choiceness-img">
                                        <img class=" cover item-img" :src="sumItem.coverImg" alt="榜单图片">
                                        <img class="heat" :src="startStr+(index+1)+endStr" alt="热度图标">
                                        <div class="example-listen">
                                            <img style="width:100%" src="icon/learnIcon/example-background.svg" alt="听众和书数量背景">
                                            <img class="example-play" src="icon/learnIcon/example-play.svg" alt="榜单播放图标">
                                            <span class="example-listenSum">{{sumItem.playCount || 0}}人收听</span>
                                            <span class="example-sum">已更新{{sumItem.segCount == typeof null ? sumItem.segCount : 0}}本</span>


                                        </div>
                                    </div>
                                    <h3>{{sumItem.title}}</h3>
                                    <div class="parameter">
                                        <span class="IitenIn">{{sumItem.introduce}}</span>
                                    </div> -->

                                </li>
                            </ul>
                            <!-- </div> -->
                            <!-- </div> -->


                        </div>


                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import externalApp from "@data/externalApp";
import adTypeEnum from '@/components/ad/adTypeEnum';

// modules
import adModule from '@comp/ad/oneImageAdModule'

const config = {
    apiConfig: {
        list: {
            url: 'portal/api/audio',
            params: {
                type: 1
            },
            dataPath: 'data.records',
            totalPath: 'data.total',
            totalPagePath: 'data.pages'
        }
    }
};


export default {
    name: "voiceCourseTopList",
    extends : shixunPagePart,
    components : { adModule },

    data() {
        return {
            adTypeEnum : adTypeEnum,
            startStr: 'icon/learnIcon/no',
            endStr: '.png',

            enableDataList: true,
            autoLoadDataList: true,
            scrollToLoadNextPage: false,
            apiConfig: config.apiConfig,


            exampleNavList: ['口碑榜', '人气榜', '飙升榜'],
            currentIndex: 0,
        }
    },
    methods: {
        currentLink(index) {
            this.currentIndex = index
            this.apiConfig.list.params.type = index + 1
            this.reloadDataList();
        },
        toDetail(id) {
            this.$router.push({name: 'albumID', params: {id: id}})
        }
    },
    mounted() {
    }
}
</script>
<style scoped lang="scss">

ul, li, input, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
}

.main {
    padding-top: 8px;
}

.margin-box {
    background: #fff;
}

.recent-changes {
    width: 100%;
    box-sizing: border-box;
    //padding: 0 18px 20px;
    padding: 0 0 20px;
}

// 标题样式
.title {
    width: 100%;
    .title-link {
        width: 100%;
        padding: 20px 0;
    }
}

//榜单样式
.content {

    .example-nav {
        width: 100%;
        height: 20px;
        line-height: 20px;
        margin-bottom: 20px;
        margin-top: 16px;
        .example-title {

            font-size: 18px;

            font-weight: 500;
            // line-height: 31px;
            color: #34353C;

        }


        .nav-box {
            li {
                list-style: none;
                float: left;
                // margin-left: 20px;
                margin-left: 8px;


                // background: #8994A9;
                background: rgba($color: #8994A9, $alpha: 0.24);
                border-radius: 25px;
                padding: 2px 7px;


                font-size: 12px;

                font-weight: 400;
                // line-height: 20px;
                color: #8994A9;


            }
            .active {
                position: relative;
                // height: 22px;

                background: #FFAE34;
                border-radius: 25px;
                padding: 2px 7px;

                font-size: 12px;

                font-weight: 500;
                // line-height: 20px;
                color: #FFFFFF;

            }
            // .active:after{
            //     content: '';
            //     display: block;
            //     position: absolute;
            //     bottom: 0;
            //     left: -2px;
            //     // width: 51px;
            //     width: 100%;
            //     height: 4px;
            //     background: #FF6767;
            // }
        }
    }

    // .example-content{
    //     width: 100%;
    //     height: 600px;
    //     display: flex;
    //     flex-direction: column;
    //     flex-wrap: wrap;
    //     justify-content: space-between;
    //     align-content: space-between;

    // }


    .example-list {
        /*height: 100%;*/
        // width: 900px;
        height: 186px;

    }


    .example-content {
        width: 100%;
        height: 186px;
        overflow-y: hidden;
        overflow-x: auto;
    }


    .example-box {
        width: 100%;
        // height: 600px;
        height: 186px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        /*justify-content: space-between;*/
        align-content: space-between;
        .radius-active {
            border-radius: 0 0 4px 4px;
        }

        // width: 100%;
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;

        .choiceness-model {
            width: 263px;
            // height: 190px;
            height: 42px;
            // border-radius: 6px;
            background: #F6F6F6;
            list-style: none;
            // padding-bottom: 5px;
            padding: 10px 0;
            padding-left: 12px;
            margin-right: 16px;

            .choiceness-item {
                display: flex;
                width: 100%;
                height: 100%;
                align-items: center;

                .choiceness-sort {
                    // width: 31px;
                    // height: 26px;
                    margin-right: 10px;
                    font-size: 20px;
                    font-family: YouSheBiaoTiHei;
                    font-weight: 400;
                    line-height: 26px;
                    color: #8994A9;

                }

                .choiceness-img {
                    width: 42px;
                    height: 42px;
                    border-radius: 4px;
                    position: relative;

                    // background: #000;
                    // z-index: 999;
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                    }

                    .img-shade {
                        position: absolute;
                        border-radius: 4px;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba($color: #000000, $alpha: 0.3);
                        .choiceness-play {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 12px;
                            height: 14px;
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAABMUlEQVRIS72WzypFURSHv68YKIWHIA9gYGpG8gSGnsBAlDKlZK6MjZUJZYCZP0MpE0NTFAZCW0td5XY7zj377rsne7LW7zt7rb3X70jhZWF9+gNIKU0C28A0MACcA5vqZe4JTSlNABfAWAexfWBVfWgKCsAhsFAh8BqnAXbU925BAXgBhmsk3gMr6kGN2N+QAKRuEoATYFm9rZPXBBC6n8AusKE+VYGaAlqaj8A6sKd+dQLlAlqaN8CSet0O6RUgdD+AeTV6lNXkqpKfqTMlAdH8ITX2n9XLErVuV1HAsTpXqkRvwJR6VwIQ13RRjf3Pyu1BsYdWdFR0PeyegZEak7HxuD4CZisA2YYzDlwBo22Q8ImwzLUsywzRNtMfBE6BrZ6Yfo3aZ4X0578o6xP/Sf4GkL2JHTi+3lcAAAAASUVORK5CYII=);
                        }

                    }

                }

                .choiceness-right {
                    flex: 1;
                    width: 100%;
                    height: 100%;
                    padding-right: 16px;
                    padding-left: 8px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                    .choicenss-title {
                        width: 100%;
                        font-size: 12px;

                        font-weight: 500;
                        // line-height: 11px;
                        color: #2C2C2C;


                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;


                    }

                    .choicenss-param {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;

                        font-size: 10px;

                        font-weight: 400;
                        line-height: 18px;
                        color: #8994A9;


                    }


                }


            }


            // .choiceness-img{
            //     width: 100%;
            //     height: 116px;
            //     border-radius: 6px 6px 0 0;
            //     position: relative;
            //     .item-img{
            //         width: 100%;
            //         height: 100%;
            //          border-radius:6px 6px 0 0;
            //     }
            //     .heat{
            //         position: absolute;
            //         top: 0;
            //         left: 10px;
            //         width: 16px;
            //         height: 22px;
            //     }
            //     .example-listen{
            //         position: absolute;
            //         bottom: 0;
            //         left: 0;
            //         width: 100%;
            //         height: 21px;

            //         .example-play{
            //             position: absolute;
            //             top: 6px;
            //             left: 6px;
            //             width: 10px;
            //             height: 10px;
            //         }


            //         .example-listenSum{
            //             position: absolute;
            //             top: 6px;
            //             left: 20px;

            //             height: 13px;
            //             font-size: 8px;
            //             font-weight: 400;
            //             line-height: 11px;
            //             color: #FFFFFF;
            //         }

            //         .example-sum{
            //             position: absolute;
            //             top: 6px;
            //             right: 6px;


            //             height: 13px;
            //             font-size: 8px;
            //             font-weight: 400;
            //             line-height: 11px;
            //             color: #FFFFFF;
            //         }
            //     }
            // }
            // h3{

            //     height: 20px;
            //     font-size: 14px;
            //     font-weight: 600;
            //     line-height: 20px;
            //     color: #333333;

            //     padding: 3px 0;
            //     padding-top: 20px;
            //     white-space:nowrap;
            //     overflow:hidden;
            //     text-overflow:ellipsis;
            //     margin: 0 5px;
            // }

            // .parameter{
            //     font-size: 10px;
            //     font-weight: 400;
            //     color: #999999;
            //     margin:0 5px;
            //     .IitenIn{
            //          text-overflow: -o-ellipsis-lastline;
            //             overflow: hidden;
            //             text-overflow: ellipsis;
            //             display: -webkit-box;
            //             -webkit-line-clamp: 2;
            //             line-clamp: 2;
            //             -webkit-box-orient: vertical;

            //     }

            // }

        }
    }
}
</style>
